import gql from 'graphql-tag';

export default gql`
  subscription refreshUnsettledOtcFills {
    unsettledOtcFills: refreshUnsettledOtcFills {
      id
      fixExecID
      order {
        id
        fixClOrdID
        fixOrderID
        fixQuoteID
        fixVenueOrderID
        instrument {
          id
        }
        side
        type
      }
      org {
        id
        name
      }
      price
      quantity
      specifiedCurrency {
        id
      }
      timeCreated
      venue {
        id
        name
        org {
          id
          name
        }
      }
    }
  }
`;
